let _expiredLicenses = [];
const observableExpiredLicenses = new Rx.BehaviorSubject(_expiredLicenses);

/**
     * @ngdoc service
     * @name repositories.ExpiredLicensesRepository
     *
     * @description
     * This class is used to save/add license objects.
     */
const ExpiredLicensesRepository = {

    /**
         * @ngdoc function
         * @name repositories.ExpiredLicensesRepository#replace
         * @methodOf repositories.ExpiredLicensesRepository
         * @function
         *
         * @description
         * This function can be used to replace all stored licenses with provided data.
         *
         * @param {Array} data An array with new licenses.
         */
    replace(data) {

        _expiredLicenses = this.getExpired(data);
        observableExpiredLicenses.onNext(_expiredLicenses);

    },

    /**
         * @ngdoc function
         * @name repositories.ExpiredLicensesRepository#getExpired
         * @methodOf repositories.ExpiredLicensesRepository
         * @function
         *
         * @description
         * This function can be used to get the expired licenses.
         *
         * @param {Array} data An array with all licenses.
         */
    getExpired(data) {

        return data.filter(license => license.attributes.expired);

    },

    /**
         * @ngdoc function
         * @name repositories.ExpiredLicensesRepository#getAll
         * @methodOf repositories.ExpiredLicensesRepository
         * @function
         *
         * @description
         * This function can be used to retrieves all licenses from repository.
         *
         * @returns {Array} all expired licenses from repository
         */
    getAll() {

        return _expiredLicenses;

    },

    /**
         * @ngdoc function
         * @name repositories.ExpiredLicensesRepository#getObservable
         * @methodOf repositories.ExpiredLicensesRepository
         * @function
         *
         * @description
         * This function can be used to get an observable object for expired licenses repository.
         * @returns {Object} an observable object for expired licenses repository.
         */
    getObservable() {

        return observableExpiredLicenses;

    },

};

export default ExpiredLicensesRepository;



// WEBPACK FOOTER //
// ./scripts/common/repositories/-RFC.expiredLicensesRepository.js